import baseService from './baseService';

export const getMyInvoices = async () => {
    try {
      const response = await baseService.get(`get-user-all-invoices`);
      return response.data;
    } catch (error) {
      throw error;
    }
 };

 export const getMyTransactions = async () => {
  try {
    const response = await baseService.get(`payments`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCarPaymentRecords = async () => {
  try {
    const response = await baseService.get(`transactions/get-all-transactions`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const refundRequestService = async (payload = {}) => {
  try {
    console.log(payload);
    const response = await baseService.put(`funds/refund-funds`, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// export const submitWireTransfer = async (wireTransferData) => {
//   try {
//     // const config = {
//     //   headers: {
//     //     'Content-Type': 'multipart/form-data',
//     //   },
//     // };
//     const response = await baseService.post('wire-transfer/create-payment', wireTransferData);
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

export const submitWireTransfer = async (wireTransferData) => {
  try {
    const isFormData = wireTransferData instanceof FormData;

    const config = isFormData
      ? {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      : {
          headers: {
            'Content-Type': 'application/json',
          },
        };

    const response = await baseService.post(
      'wire-transfer/create-payment',
      wireTransferData,
      config
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getWireTransferHistory = async () => {
  try {
    const response = await baseService.get('/wire-transfer/get-payments-by-user');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getUserRefunds = async () => {
  try {
    const response = await baseService.get('refunds/get-user-refunds');
    return response.data;
  } catch (error) {
    throw error;
  }
};